import React, { useEffect } from "react";
import type { ComponentProps } from "react";
import { Modal } from "antd";
import type { ModalProps } from "antd";
import { OfferList } from "../OfferList";
import { Offer } from "../../../lib/types";
import "./OfferListModal.less";

interface IProps {
  visible: boolean;
  onOk: (offer: Offer<string>) => void;
  onCancel: () => void;
  offerListProps: ComponentProps<typeof OfferList>;
}

export const OfferListModal = (props: IProps) => {
  const { visible, onOk, onCancel, offerListProps } = props;

  // Очистка результатов поиска групп при закрытии модалки
  useEffect(() => {
    if (!visible) {
      offerListProps.onResetSearch();
    }
  }, [visible]);

  const onClose = () => {
    offerListProps.onResetSearch();
    onCancel();
  };

  const modalProps: ModalProps = {
    visible,
    width: "100%",
    okButtonProps: {
      style: {
        width: "108px",
      },
      onClick: () => {
        if (offerListProps.selectedOffer) {
          onOk(offerListProps.selectedOffer);
        }
      },
      disabled: !offerListProps.selectedOffer,
    },
    cancelButtonProps: {
      style: {
        width: "108px",
      },
      onClick: onClose,
    },
    onCancel: onClose,
  };

  return (
    <Modal className="offer-list-modal" {...modalProps}>
      <OfferList {...offerListProps} />
    </Modal>
  );
};
